export default {
  id: 220,
  title: 'Target #220 - Building',
  url: 'https://cssbattle.dev/play/220',
  colors: ['#67AED4', '#0F2836', '#FFFFFF'],
  solution:
    '<p a><p b><p c><p d><p e><style>p[a],p[b],p[c]{height:60;background:#fff}p[a],p[b],p[c],p[d]{background:#fff}body,p[e]{background:#67aed4}p{position:fixed;margin:0}p[a]{top:20;left:194;width:12}p[b]{top:80;left:170;width:60}p[c]{top:140;left:150;width:100}p[d]{top:200;left:0;width:400;height:100}p[e]{top:220;left:-10;width:40;height:80;box-shadow:60px 0 #67aed4,120px 0 #67aed4,260px 0 #67aed4,320px 0 #67aed4,380px 0 #67aed4,180px 0 #0f2836,200px 0 #0f2836',
}
